import React from "react";
import { useTable } from "../../Components/useTable";

const User = () => {
  const type = "Active Users";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "code", numeric: false, label: "RID" },
    { id: "name", numeric: false, label: "Name" },
    { id: "picture", numeric: false, label: "Profile Picture" },
    { id: "email", numeric: false, label: "Email" },
    { id: "phone", numeric: false, label: "Phone" },
    { id: "banned", numeric: false, label: "Status" },
    { id: "type", numeric: false, label: "Type" },
    // { id: "firebaseUid", numeric: false, label: "Firebase UUid" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default User;
